module.exports = __webpack_public_path__ + "img/empty-associated-dark.b87c0bc.svg";